const GoogleAdSmall2 = () => {
  return (
    <>
      <div className="rbt-callto-action rbt-cta-default style-4 bg-gradient-3 mt--20">
        <a href="https://www.dpbolvw.net/click-101154220-15255254" target="_top">Get $350 in product credits and free usage of 20+ products on Google Cloud.</a><img src="https://www.ftjcfx.com/image-101154220-15255254" width="1" height="1" border="0" />
      </div>
    </>
  );
};

export default GoogleAdSmall2;
